// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/specific/ProductCard.css */
.product-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.product-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.product-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.product-card:hover .product-image img {
  transform: scale(1.05);
}

.product-category {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(102, 126, 234, 0.9);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
}

.low-stock {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(229, 62, 62, 0.9);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 500;
}

.product-info {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.product-name {
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #2d3748;
}

.product-rating {
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
}

.star {
  font-size: 1rem;
  margin-right: 2px;
}

.star.full {
  color: #fbbf24;
}

.star.half {
  color: #fbbf24;
  position: relative;
}

.star.half::after {
  content: '★';
  position: absolute;
  left: 0;
  color: #e2e8f0;
  z-index: -1;
}

.star.empty {
  color: #e2e8f0;
}

.rating-value {
  margin-left: 0.5rem;
  font-size: 0.875rem;
  color: #718096;
}

.product-price {
  font-size: 1.5rem;
  font-weight: 700;
  color: #667eea;
  margin-bottom: 1rem;
}

.product-actions {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.add-to-cart-btn {
  width: 100%;
}

.quick-view-btn {
  width: 100%;
}

.login-prompt {
  text-align: center;
  color: #718096;
  font-style: italic;
  padding: 0.5rem;
}

.product-details-expanded {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.product-description {
  color: #718096;
  line-height: 1.5;
  margin-bottom: 1rem;
}

.product-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  color: #a0aec0;
}

.stock-status.in-stock {
  color: #38a169;
}

.stock-status.low {
  color: #e53e3e;
  font-weight: 500;
}

.user-specific {
  margin-top: 0.75rem;
  padding: 0.5rem;
  background-color: #f0fff4;
  border-radius: 4px;
  font-size: 0.875rem;
  color: #2f855a;
}

/* Responsive design */
@media (max-width: 768px) {
  .product-card {
    max-width: 100%;
  }
  
  .product-image {
    height: 180px;
  }
  
  .product-info {
    padding: 1rem;
  }
  
  .product-name {
    font-size: 1.1rem;
  }
  
  .product-price {
    font-size: 1.3rem;
  }
}

/* Animation for add to cart feedback */
@keyframes addedToCart {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

.add-to-cart-btn:disabled {
  animation: addedToCart 0.5s ease;
  background-color: #38a169;
}`, "",{"version":3,"sources":["webpack://./src/components/specific/ProductCard.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,uCAAuC;AACvC;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B","sourcesContent":["/* src/components/specific/ProductCard.css */\n.product-card {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.product-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n.product-image {\n  position: relative;\n  height: 200px;\n  overflow: hidden;\n}\n\n.product-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.product-card:hover .product-image img {\n  transform: scale(1.05);\n}\n\n.product-category {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: rgba(102, 126, 234, 0.9);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.low-stock {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(229, 62, 62, 0.9);\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.product-info {\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.product-name {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #2d3748;\n}\n\n.product-rating {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.star {\n  font-size: 1rem;\n  margin-right: 2px;\n}\n\n.star.full {\n  color: #fbbf24;\n}\n\n.star.half {\n  color: #fbbf24;\n  position: relative;\n}\n\n.star.half::after {\n  content: '★';\n  position: absolute;\n  left: 0;\n  color: #e2e8f0;\n  z-index: -1;\n}\n\n.star.empty {\n  color: #e2e8f0;\n}\n\n.rating-value {\n  margin-left: 0.5rem;\n  font-size: 0.875rem;\n  color: #718096;\n}\n\n.product-price {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #667eea;\n  margin-bottom: 1rem;\n}\n\n.product-actions {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.add-to-cart-btn {\n  width: 100%;\n}\n\n.quick-view-btn {\n  width: 100%;\n}\n\n.login-prompt {\n  text-align: center;\n  color: #718096;\n  font-style: italic;\n  padding: 0.5rem;\n}\n\n.product-details-expanded {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #e2e8f0;\n}\n\n.product-description {\n  color: #718096;\n  line-height: 1.5;\n  margin-bottom: 1rem;\n}\n\n.product-meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.875rem;\n  color: #a0aec0;\n}\n\n.stock-status.in-stock {\n  color: #38a169;\n}\n\n.stock-status.low {\n  color: #e53e3e;\n  font-weight: 500;\n}\n\n.user-specific {\n  margin-top: 0.75rem;\n  padding: 0.5rem;\n  background-color: #f0fff4;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  color: #2f855a;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .product-card {\n    max-width: 100%;\n  }\n  \n  .product-image {\n    height: 180px;\n  }\n  \n  .product-info {\n    padding: 1rem;\n  }\n  \n  .product-name {\n    font-size: 1.1rem;\n  }\n  \n  .product-price {\n    font-size: 1.3rem;\n  }\n}\n\n/* Animation for add to cart feedback */\n@keyframes addedToCart {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n  100% { transform: scale(1); }\n}\n\n.add-to-cart-btn:disabled {\n  animation: addedToCart 0.5s ease;\n  background-color: #38a169;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
